module.exports = __webpack_public_path__ + "img/PC_d.1c891f8c.png";